module.exports = __webpack_public_path__ + "media/images/getting-started/enable-link-9dbe8b862eefe7109e68c52fd2a6266c.gif";